import type { TextProps } from "@similarweb/ui-components/foundations";
import { Text } from "@similarweb/ui-components/foundations";

export const Column = ({
    textAlign = "right",
    ...props
}: Pick<TextProps, "fontVariant" | "textAlign" | "children">) => (
    <Text
        flex="1 1 0"
        minWidth="0"
        textAlign={textAlign}
        {...props}
    />
);
